import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchAssetDetails({ payload }) {
  try {
    const res = yield call(API.fetchKitDetails, payload?.assetId);
    const { data } = res;
    yield put(actions.fetchKitDetailsSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.fetchKitDetailsFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleFetchProjects({ payload }) {
  try {
    const res = yield call(API.fetchAllCompaniesProjectCodes, payload);
    const { data } = res;
    yield put(actions.fetchProjectsSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectsFailure(err?.response?.data));
  }
}

export function* handleUpdateProjectCode({ payload }) {
  try {
    const res = yield call(API.updateKitProjectCode, payload);
    yield put(actions.updateProjectCodeSuccess());
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.updateProjectCodeFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleAddSeals({ payload }) {
  try {
    const res = yield call(API.addSeals, payload);
    const { data } = res;
    yield put(actions.addSealsSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.addSealsFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleAddBoxes({ payload }) {
  try {
    const res = yield call(API.addBoxes, payload);
    const { data } = res;
    yield put(actions.addBoxSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.addBoxFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleDeleteKit({ payload }) {
  try {
    const res = yield call(API.deleteKit, payload);
    const { data } = res;
    yield put(actions.deleteKitSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.deleteKitSuccess(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleFetchEligibleOrders({ payload }) {
  try {
    const res = yield call(API.fetchEligibleOrders, { samplerBoxId: payload?.samplerBoxId });
    const { validOrders } = res.data;
    yield put(actions.fetchEligibleOrdersSuccess(validOrders));
    payload?.onSuccess && payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchEligibleOrdersFailure(err?.response?.data));
    payload?.onFailure && payload.onFailure(err?.response?.data);
  }
}

export function* handleAddOrdersToBox({ payload }) {
  try {
    const res = yield call(API.addOrdersToBox, payload?.postData);
    const { data } = res;
    yield put(actions.addOrdersToBoxSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.addOrdersToBoxFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleRemoveOrderFromBox({ payload }) {
  try {
    const res = yield call(API.removeOrderFromBox, payload?.postData);
    const { data } = res;
    yield put(actions.removeOrderFromBoxSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.removeOrderFromBoxFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleChangeBoxStatus({ payload }) {
  try {
    const res = yield call(API.changeBoxStatusByAdmin, payload?.postData);
    const { data } = res;
    yield put(actions.changeBoxStatusSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.changeBoxStatusFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleMarkSealAsUnused({ payload }) {
  try {
    const res = yield call(API.markSealAsUnusedByAdmin, payload?.sampleSealId);
    const { data } = res;
    yield put(actions.markSealAsUnusedSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.markSealAsUnusedFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleGetSampleSealTypes({ payload }) {
  try {
    const res = yield call(API.getSampleSealType, payload);
    const { data } = res;
    yield put(actions.getSampleSealTypesSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.getSampleSealTypesFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleAddSticker({ payload }) {
  try {
    const res = yield call(API.addSticker, payload);
    const { data } = res;
    yield put(actions.addStickerSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.addStickerFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleAddDevice({ payload }) {
  try {
    const res = yield call(API.addDevice, payload);
    const { data } = res;
    yield put(actions.addDeviceSuccess(data));
    payload?.onSuccess(data);
  } catch (err) {
    yield put(actions.addDeviceFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* assetDetailsSaga() {
  yield takeLatest(actions.fetchKitDetails.type, handleFetchAssetDetails);
  yield takeLatest(actions.fetchProjects.type, handleFetchProjects);
  yield takeEvery(actions.updateProjectCode.type, handleUpdateProjectCode);
  yield takeEvery(actions.addSeals.type, handleAddSeals);
  yield takeEvery(actions.addBox.type, handleAddBoxes);
  yield takeEvery(actions.deleteKit.type, handleDeleteKit);
  yield takeLatest(actions.fetchEligibleOrders.type, handleFetchEligibleOrders);
  yield takeEvery(actions.addOrdersToBox.type, handleAddOrdersToBox);
  yield takeEvery(actions.removeOrderFromBox.type, handleRemoveOrderFromBox);
  yield takeEvery(actions.changeBoxStatus.type, handleChangeBoxStatus);
  yield takeEvery(actions.markSealAsUnused.type, handleMarkSealAsUnused);
  yield takeLatest(actions.getSampleSealTypes.type, handleGetSampleSealTypes);
  yield takeEvery(actions.addSticker.type, handleAddSticker);
  yield takeEvery(actions.addDevice.type, handleAddDevice);
}